import { Alert } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'

import * as S from '../styles'

type InternalErrorProps = {
  message?: string
  details?: string
  onBack: () => void
}

export const InternalError = ({
  message,
  details,
  onBack
}: InternalErrorProps) => {
  return (
    <S.ErrorContainer>
      <S.ErrorListContainer>
        <Alert variant="critical">
          <S.AlertContent>
            {message && (
              <S.InternalErrorMessage>{message}</S.InternalErrorMessage>
            )}
            {details && (
              <S.InternalErrorDetails>{details}</S.InternalErrorDetails>
            )}
            {!message && !details && (
              <div>
                {t(
                  'rm:externalCampaignMetrics.form.error.internalError.message'
                )}
              </div>
            )}
          </S.AlertContent>
        </Alert>
      </S.ErrorListContainer>

      <S.ButtonContainer>
        <Button
          text={t('rm:externalCampaignMetrics.form.error.back')}
          template="primary"
          onClick={onBack}
        />
      </S.ButtonContainer>
    </S.ErrorContainer>
  )
}
